// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4773daa1","239":"5813ae91","453":"0c663429","455":"e6cffa53"}[chunkId] + ".chunk.js";
};